import React, { useState } from 'react';
import InvoiceForm from './InvoiceForm';
import InvoicePreview from '../components/InvoicePreview';
import PreviousInvoices from '../components/PreviousInvoices';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

const MainInvoice = () => {
    const [view, setView] = useState('new');

    const [invoiceData, setInvoiceData] = useState({
        customerName: '',
        address: '',
        mobile:'',
        gstin: '',
        invoiceNumber: '',
        invoiceDate: '',
        dueDate: '',
        items: [],
        cgst: 0,
        sgst: 0,
        grossAmount: 0
    });

    const handleViewChange = (_, newView) => {
        if (newView !== null) setView(newView);
    };

    return (
        <div className="p-6 bg-white shadow-md rounded-lg w-full">
            <div className="flex justify-between items-center mb-6">
                <ToggleButtonGroup
                    value={view}
                    exclusive
                    onChange={handleViewChange}
                    aria-label="invoice view toggle"
                >
                    <ToggleButton value="new" className="!text-sm !px-4 !py-2 !capitalize">New Invoice</ToggleButton>
                    <ToggleButton value="previous" className="!text-sm !px-4 !py-2 !capitalize">Previous Invoices</ToggleButton>
                </ToggleButtonGroup>
            </div>

            {view === 'new' ? (
                <div className="grid gap-6">
                    <InvoiceForm invoiceData={invoiceData} setInvoiceData={setInvoiceData} />
                </div>
            ) : (<PreviousInvoices />)}

            <div className="mt-8 border-t pt-4 text-sm text-gray-600">
                <p>Company Bank: HDFC Bank, A/C: 1234567890, IFSC: HDFC0000123</p>
                <p>PAN: ABCDE1234F | GST: 29ABCDE1234F1Z5</p>
            </div>
        </div>
    );
};

export default MainInvoice;
